//@flow
import React, {useEffect} from 'react';
import {Close} from '@material-ui/icons';
import {useDeviceReconnect, useStoreDevices} from '../../../../../../utils';
import {useHistory} from 'react-router-dom';
import {colors} from '../../../../../../../../../assets/styles/colors';
import {makeStyles, ButtonBase} from '@material-ui/core';
import {useCurrentConversation} from '../../../../../../utils/conversation';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'absolute',
    bottom: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999,
  },
  label: {
    paddingInline: '.5rem',
    fontWeight: 600,
  },
  description: {
    paddingInline: '.5rem',
    fontSize: '0.8rem',
    color: colors.grey600,
    textAlign: 'left',
    margin: 0,
  },
  descriptionLink: {
    color: colors.grey700,
    fontWeight: 600,
  },
  notificationButton: {
    padding: '.5rem',
    display: 'flex',
    gap: '.5rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    transition: 'transform 0.2s ease-in-out, boxShadow 0.2s ease-in-out',
    // backdropFilter: 'blur(2rem)',
    background: `#f2dce4`,
    borderRadius: '1rem',
    // width: '50%',
  },
  notificationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'fit-content',
  },
  count: {
    width: '24px',
    height: '24px',
    fontWeight: 600,
    borderRadius: '50%',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&[data-theme="primary"]': {
      background: colors.primary,
      color: 'white',
    },
    '&[data-theme="secondary"]': {
      background: colors.secondary,
      color: 'white',
    },
    '&[data-theme="success"]': {
      background: colors.success,
      color: 'white',
    },
    '&[data-theme="warning"]': {
      background: colors.warning,
      color: 'white',
    },
    '&[data-theme="info"]': {
      background: colors.info,
      color: 'white',
    },
    '&[data-theme="danger"]': {
      background: colors.danger,
      color: 'white',
    },
  },
  icon: {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.35rem',
  },
  closeButton: {
    width: '20px',
    height: '20px',
    color: 'white',
    background: colors.danger,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function DisconnectMessageNotification() {
  const history = useHistory();
  const classes = useStyles();

  const {qrCodeReconnect, resetReconnect} = useDeviceReconnect();
  const {
    reconnectDevice,
    storeDevices,
    // isLoading,
  } = useStoreDevices({
    refetchOnMount: true,
  });
  const {currentConversation} = useCurrentConversation();

  const whatsappDevice =
    storeDevices.find(
      device =>
        device.id === currentConversation?.deviceId &&
        device.service === 'WHATSAPP_WEB' &&
        device.state === 'DISCONNECTED'
    ) ||
    storeDevices.find(
      device =>
        device.service === 'WHATSAPP_WEB' && device.state === 'DISCONNECTED'
    );

  const handleReconnect = () => {
    if (!whatsappDevice) return;
    reconnectDevice(whatsappDevice?.id, whatsappDevice?.service);
  };

  useEffect(() => {
    if (qrCodeReconnect && whatsappDevice) {
      history.push(`/chat/configuration/whatsapp`);
    }
  }, [history, qrCodeReconnect, whatsappDevice]);

  useEffect(() => {
    return () => {
      resetReconnect();
    };
  }, [resetReconnect]);

  return (
    <aside className={classes.root}>
      <ButtonBase
        onClick={handleReconnect}
        className={classes.notificationButton}
        data-theme={'danger'}
      >
        <div className={classes.notificationHeader}>
          <ButtonBase
            className={classes.closeButton}
            onClick={e => {
              e.stopPropagation();
              // handleCloseClick();
            }}
          >
            <Close fontSize="small" />
          </ButtonBase>
          <span className={classes.label} data-theme={'danger'}>
            Tu número se ha desconectado
          </span>
        </div>

        <p className={classes.description}>
          Por favor reconectar el número de WhatsApp. <br />
          <span className={classes.descriptionLink}>Click aquí</span>
        </p>
      </ButtonBase>
    </aside>
  );
}
